/**
 * AM.One API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ConceptDetailDtoMetadata { 
    id: string;
    type: ConceptDetailDtoMetadata.TypeEnum;
    title: string;
    author: string;
    /**
     * Latest Git commit author for the document file, when available.
     */
    lastEditedBy?: string | null;
    created: string;
    lastModified: string;
    categories: Array<string>;
    supersedes?: string | null;
    supersededBy?: string | null;
    relatesToList: Array<string>;
    epic?: string | null;
    relativePath?: string;
    unresolvedComments: Array<string>;
}
export namespace ConceptDetailDtoMetadata {
    export const TypeEnum = {
        Concept: 'concept'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


